import React, {useState} from 'react';
import {useStores} from "./App";
import {Observer} from "mobx-react-lite";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLink, faChevronUp, faChevronDown, faMapMarked} from "@fortawesome/free-solid-svg-icons";
import {take} from 'lodash-es';

const headers = [
  "Título de la nota ",
  "Autor",
  "Medio",
  "Fecha de publicación",
  "Nombre del MP",
  "Vínculo",
];


export const Resultados = () => {
  const {appStore} = useStores();
  return (<Observer>
    {() => <div id='resultados' className='flex p-4 mt-3 bg-gray-200 border border-gray-300 rounded-lg'>
      <div className='flex-grow'>
        <table className="w-full table-auto">
          <thead>
            <tr>
              {headers.map((th, i) =>
                <th key={i} className='sticky top-0 p-2 bg-blue-100 border border-gray-400'>
                  {th}
                </th>)}
            </tr>
          </thead>
          <tbody>
            {appStore.searchResults.map((n, i) =>
              <tr key={i}
                className="align-top bg-white even:bg-gray-200 hover:bg-blue-100">
                <td className='p-2 border border-gray-400'>{n.titulo}</td>
                <td className='p-2 border border-gray-400'>{n.autor}</td>
                <td className='p-2 whitespace-no-wrap border border-gray-400'>{n.nombre_medio}</td>
                <td className='p-2 border border-gray-400'>{n.fecha}</td>
                <td className='border border-gray-400'>
                  <Listado items={n.proyectos} />
                </td>
                <td className='p-2 text-center border border-gray-400'>
                  {n.vinculo ?
                    <a href={n.vinculo}
                      target='_blank'
                      rel='noopener noreferrer'
                    ><FontAwesomeIcon
                        className='text-blue-500 hover:text-blue-600'
                        icon={faLink} />
                    </a>
                    : null
                  }
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>}
  </Observer>)
};

const Listado = ({items}: {items: string[]}) => {
  const item = (item: string, key: number) => (<li className="px-5 py-4 even:bg-blue-100" key={key}>
    {item}
    <a href={`/ocs/?Nombre+del+megaproyecto=${encodeURIComponent(item)}`}
      className='text-blue-500 hover:text-blue-600'
      target='_blank'
      rel='noopener noreferrer'
    >
      <FontAwesomeIcon icon={faMapMarked} className="ml-2 text-sm" title="Ver en mapa" />
    </a>
  </li>)
  const [shown, setShown] = useState(false);
  const toggleShown = () => setShown(v => !v);
  items = items.slice().sort((a, b) => b.length - a.length);
  return <>
    <ul className='flex flex-col flex-grow list-disc list-inside'
      style={{minWidth: '200px'}}>
      {
        shown || items.length <= 3 ?
          items.map(item)
          : <>
            {take(items, 3).map(item)}
          </>
      }
    </ul>
    {items.length > 3 ?
      <div className="py-2 mt-2 text-center text-gray-500 cursor-pointer text-bold"
        onClick={toggleShown}>
        <FontAwesomeIcon icon={shown ? faChevronUp : faChevronDown} className="mr-2 text-sm text-gray-500" />{shown ? 'Ocultar' : 'Ver más'}</div>
      : null
    }</>
};
